const NAV_LINKS = [
  { label: 'Início', href: '#hero' },
  { label: 'Soluções', href: '#solucoes' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Sobre Mim', href: '#sobre' },
  { label: 'Contato', href: '#contato' },
];

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const LOGO_AZUL_URL = 'https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/c476719b-eb6f-495e-af3c-dd0d03c293a9_logo_azul.png?v=da892f725d15e3310a5a02f038d58849';

const LOGO_ORIGINAL_URL = 'https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/87096cb3-6509-4cf5-9645-ecbc3c928ac5_logo-01.png.png?v=97043be2c98d3484e9626a0e816c7bdf';



export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-white py-14 md:py-20 px-4 md:px-6 lg:px-10 border-t border-gray-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={LOGO_AZUL_URL}
                alt="Logo Patrick Serafini"
                className="w-10 h-10 object-contain flex-shrink-0"
              />
              <span className="font-cinzel font-semibold text-navy text-lg">
                Patrick Serafini
              </span>
            </div>
            <h3 className="font-cinzel font-bold text-navy text-2xl md:text-3xl leading-tight">
              Defesa Criminal
              <br />
              Especializada
            </h3>
            <p className="font-montserrat font-light text-grey text-sm md:text-base mt-4 max-w-sm leading-relaxed">
              Atuação dedicada em Direito Criminal no Sul de Minas. Orientação jurídica
              técnica, ética e humanizada para proteger seus direitos em momentos críticos.
            </p>
          </div>

          {/* Links Columns */}
          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="font-montserrat font-semibold text-navy text-sm mb-4">Navegação</h4>
              <ul className="space-y-3">
                {NAV_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="font-montserrat font-light text-grey text-sm hover:text-navy transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-montserrat font-semibold text-navy text-sm mb-4">Especialidades</h4>
              <ul className="space-y-3">
                <li><span className="font-montserrat font-light text-grey text-sm">Flagrantes 24h</span></li>
                <li><span className="font-montserrat font-light text-grey text-sm">Revisão Criminal</span></li>
                <li><span className="font-montserrat font-light text-grey text-sm">Tribunal do Júri</span></li>
                <li><span className="font-montserrat font-light text-grey text-sm">Audiência de Custódia</span></li>
              </ul>
            </div>
            <div>
              <h4 className="font-montserrat font-semibold text-navy text-sm mb-4">Contato</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-montserrat font-light text-grey text-sm hover:text-navy transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
                <li>
                  <span className="font-montserrat font-light text-grey text-sm">
                    Sul de Minas — MG
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Credits */}
        <div className="mt-12 md:mt-16 pt-6 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <img
              src={LOGO_AZUL_URL}
              alt="Logo Patrick Serafini"
              className="w-6 h-6 object-contain flex-shrink-0"
            />
            <p className="font-montserrat font-light text-grey text-xs md:text-sm flex items-center gap-1">
              Desenvolvido por Renan Costa
              <span className="hidden sm:inline">—</span>
              <a
                href="https://instagram.com/renancostaw"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 hover:text-navy transition-colors"
              >
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                @renancostaw
              </a>
            </p>
          </div>
          <p className="font-montserrat font-light text-grey-light text-xs mt-3 text-center">
            © {new Date().getFullYear()} Patrick Serafini Advocacia. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}